import axios from 'axios';
import api from '../services/api';
import { request_error } from './request_error';

import {
  GET_USER_PERSONAL_DETAILS_SUCCESS,
  GET_USER_PERSONAL_DETAILS_FAIL,
} from './types';

const USER_PERSONAL_DETAILS_ENDPOINT = 'user/personal_details';
export const getUserPersonalDetails = () => async dispatch => {
  try {
    let { data } = await api.get(`${USER_PERSONAL_DETAILS_ENDPOINT}`);

    dispatch({ type: GET_USER_PERSONAL_DETAILS_SUCCESS, payload: data });
  } catch (e) {
    request_error(e);
    return dispatch({ type: GET_USER_PERSONAL_DETAILS_FAIL })
  }
}
